// extracted by mini-css-extract-plugin
export default {"Button":"ScrollDownButton-module__Button--a1yTa"};